const prefix = 'fasr';
const iconName = 'ellipsis-stroke';
const width = 512;
const height = 512;
const aliases = ['ellipsis-h-alt'];
const unicode = 'f39b';
const svgPathData = 'M72 232l48 0 0 48-48 0 0-48zM32 280l0 40 40 0 48 0 40 0 0-40 0-48 0-40-40 0-48 0-40 0 0 40 0 48zm200-48l48 0 0 48-48 0 0-48zm-40 48l0 40 40 0 48 0 40 0 0-40 0-48 0-40-40 0-48 0-40 0 0 40 0 48zm200 0l0-48 48 0 0 48-48 0zm-40 40l40 0 48 0 40 0 0-40 0-48 0-40-40 0-48 0-40 0 0 40 0 48 0 40z';

export default {
  prefix,
  iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ] };
